// MODULES //

import ProportionsInput from './main.js';


// EXPORTS //

export default ProportionsInput;
